"use client"

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

import type { AppShortcutCommandId, ShortcutCommandDefinition } from "@/lib/shortcuts/commands"

interface KeyboardShortcutsModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  commands: ShortcutCommandDefinition[]
  getShortcutLabel: (commandId: AppShortcutCommandId) => string
}

export function KeyboardShortcutsModal({
  open,
  onOpenChange,
  commands,
  getShortcutLabel,
}: KeyboardShortcutsModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>Keyboard shortcuts</DialogTitle>
          <DialogDescription>
            Use these shortcuts to navigate and trigger actions quickly.
          </DialogDescription>
        </DialogHeader>

        <div className="max-h-[55vh] overflow-y-auto rounded-md border">
          <div className="divide-y">
            {commands.map((command) => (
              <div key={command.id} className="flex items-center justify-between gap-6 px-4 py-3">
                <span className="text-sm text-foreground">{command.label}</span>
                <kbd className="rounded-md border bg-muted px-2 py-1 text-xs font-medium text-muted-foreground">
                  {getShortcutLabel(command.id)}
                </kbd>
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

